// Server caps jobs accepted per POST /vehicle-images at this value (so a
// malformed payload can't fan out unbounded upstream GV calls). Client uses
// the same number as the chunk size when batching the deferred-image cohort.
export const MAX_VEHICLE_IMAGE_JOBS = 200;
